<template>
  <div style="margin-top: 10px;;">
    <b-tabs
      v-model="tabIndex"
      @input="handleTabChanged"
    >
      <b-tab>
        <template #title>
          <strong style="font-weight: 500; color: black">{{ $t("CreateOrderMovementGenerally") }}</strong>
        </template>
        <InPendingArticlesAndOrders ref="inPendingArticlesAndOrders" />

      </b-tab>
      <b-tab>
        <template #title>
          <strong style="font-weight: 500; color: black">{{ $t("CreateOrderMovementInternal") }}</strong>
        </template>
        <InPendingArticlesAndOrdersInternal ref="inPendingArticlesAndOrdersInternal" />
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import InPendingArticlesAndOrders from '@/components/InternalMovement/InPendingArticlesAndOrders.vue'
import InPendingArticlesAndOrdersInternal from './InPendingArticlesAndOrdersInternal.vue';

export default {
  components: {
    InPendingArticlesAndOrders,
    InPendingArticlesAndOrdersInternal,
  },
  data() {
    return {
      tabIndex: 0,
    }
  },
  methods: {
    handleTabChanged(newTabIndex) {
      if (newTabIndex === 0) {
        this.$refs.inPendingArticlesAndOrders.resetData();
      } else if (newTabIndex === 1) {
        this.$refs.inPendingArticlesAndOrdersInternal.resetData();
      }
    },
    updateData() {
      if (this.tabIndex === 0) {
        this.$refs.inPendingArticlesAndOrders.resetData();
      } else if (this.tabIndex === 1) {
        this.$refs.inPendingArticlesAndOrdersInternal.resetData();
      }
    },
  },
}
</script>

<style scoped>

</style>
